/** @hidden */
export function parseJwt(token: string) {
  try {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(window.atob(base64));
  } catch (e) {
    console.error(`[ArcSDK] Error parsing JWT: ${token}
    ${e}`);
  }
}

/** @hidden */
export function isJwtExpired(token: string) {
  const jwtPayload = parseJwt(token);
  return 1000 * jwtPayload.exp <= Date.now(); // jwt dates are in seconds since epoch, hence "1000 *"
}

/** @hidden */
export function jwtHasExp(token: string) {
  const jwt = parseJwt(token);
  return !!jwt.exp;
}
